export default "__VITE_ASSET__e$N0MmnJ__"